import moment from 'moment';
import tippy from 'tippy.js';
import { ClientTable, Event } from 'vue-tables-2';
import { select, selectAll, toggleExpandablePanel } from '../shared/utils/dom';
import dataLayerPush from '../shared/utils/analytics';

window.moment = moment;

function formatCurrency(row) {
  const amount = row.Amount;

  // add currency puncuation as needed
  let isNegative = row.Pending; // do this so when there is a pending payment it is marked negative to.
  if (amount < 0) {
    isNegative = true;
  }
  const formatted = parseFloat(Math.abs(amount)).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
  if (isNegative) {
    return `($${formatted})`;
  }
  return `$${formatted}`;
}

function AdjustHistoryTableMargin() {
  const DOM = {
    dashboardfirstsection: select('#dashboard-first-section'),
    dashboardsecondsection: select('#dashboard-second-section'),
    dashboardthirdsection: select('#dashboard-third-section'),
  };
  if (DOM.dashboardthirdsection) {
    DOM.dashboardthirdsection.style.marginTop = `0px`;
  }
  if (window.innerWidth > 1024 && DOM.dashboardfirstsection && DOM.dashboardsecondsection && DOM.dashboardthirdsection) {
    if (DOM.dashboardfirstsection.clientHeight < DOM.dashboardsecondsection.clientHeight) {
      DOM.dashboardthirdsection.style.marginTop = `${(((DOM.dashboardfirstsection.clientHeight) - (DOM.dashboardsecondsection.clientHeight)) - 15)}px`;
    }
  }
}

export default function () {
  const el = select('[data-vue-app="history-table"]');
  if (!el) {
    return;
  }

  Vue.use(ClientTable);
  const rowData = function (date) {
    return {
      'Description': 'Description', // eslint-disable-line quote-props
      'Date': date, // eslint-disable-line quote-props
      'Amount': 32.5, // eslint-disable-line quote-props
      'Type': 'Abcdef', // eslint-disable-line quote-props
      'BillId': '123456', // eslint-disable-line quote-props
      'Pending': false, // eslint-disable-line quote-props
      'UrlLink': 'Abcdef', // eslint-disable-line quote-props
      'AllowUrlLink': false, // eslint-disable-line quote-props
    };
  };
  new Vue({ // eslint-disable-line no-new
    el,
    data() {
      return {
        columns: [
          'Date',
          'Type',
          'Description',
          'Amount',
          'BillId',
        ],
        tableData: window.VueTables.historyData || [
          rowData('2017-02-21T00:00:00Z'),
          rowData('2017-01-23T00:00:00Z'),
          rowData('2016-12-20T00:00:00Z'),
          rowData('2016-11-17T00:00:00Z'),
          rowData('2016-10-19T00:00:00Z'),
          rowData('2016-09-20T00:00:00Z'),
          rowData('2016-08-19T00:00:00Z'),
          rowData('2016-07-21T00:00:00Z'),
          rowData('2016-06-21T00:00:00Z'),
          rowData('2016-05-20T00:00:00Z'),
          rowData('2016-04-21T00:00:00Z'),
          rowData('2016-03-22T00:00:00Z'),
        ],
        options: {
          filterable: false,
          dateColumns: ['Date'],
          dateFormat: 'MMM D, YYYY',
          toMomentFormat: 'YYYY-MM-DD',
          orderBy: {
            ascending: false,
            column: 'Date',
          },
          headings: {
            'Date': 'Transaction Date', // eslint-disable-line quote-props
            'Type': 'Type', // eslint-disable-line quote-props
            'Description': 'Description', // eslint-disable-line quote-props
            'Amount': 'Amount', // eslint-disable-line quote-props
            'BillId': '', // eslint-disable-line quote-props
          },
          perPage: 10,
          sortable: ['Date', 'Type', 'Description', 'Amount'],
          templates: {
            Date: (h, row) => {
              const pending = (row.Type === 'Payment' && row.Pending) ? `Will process on ` : ``;
              return (
                <div class="table-cell-wrapper">
                  <div class="table-cell-label">Transaction Date</div>
                  <div class="table-cell-content">
                    {pending}
                    {row.Date}
                  </div>
                </div>
              );
            },
            Type: (h, row) => (
              <div class="table-cell-wrapper">
                <div class="table-cell-label">Type</div>
                <div class="table-cell-content">{row.Type}</div>
              </div>
            ),
            Description: (h, row) => (
              <div class="table-cell-wrapper">
                <div class="table-cell-label">Description</div>
                <div class="table-cell-content">{row.Description}</div>
              </div>
            ),
            Amount: (h, row) => (
              <div class="table-cell-wrapper">
                <div class="table-cell-label">Amount</div>
                <div class="table-cell-content">{formatCurrency(row)}</div>
              </div>
            ),
            BillId: (h, row) => {
              if (row.Type === 'Bill') {
                if (row.IsPaperless && row.AllowUrlLink === true) {
                  return (
                    <div class="table-cell-wrapper">
                      <div class="table-cell-label">Download PDF of Bill</div>
                      <div class="table-cell-content view-bill">
                        <a href={row.UrlLink} target="_blank">
                          <svg
                            aria-hidden="true"
                            class="icon icon--blue icon-pdf"
                            role="img"
                          >
                            <use xlinkHref="#icon-pdf"></use>
                          </svg>
                          <p>View Bill</p>
                        </a>
                      </div>
                    </div>
                  );
                } else if (row.ShowPaperlessEnroll) {
                  return (
                    <div class="table-cell-wrapper">
                      <div class="table-cell-label">Enroll in Paperless</div>
                      <div class="table-cell-content paperless">
                        <a href="/ebill">
                          <svg
                            aria-hidden="true"
                            class="icon color-gray icon-paperless"
                            role="img"
                          >
                            <use xlinkHref="#icon-paperless"></use>
                          </svg>
                          <p>Enroll in Paperless</p>
                        </a>
                        <span
                          class="tooltip tooltip__container paperless"
                          title="<p class='text-center'>
                            You need to enroll in
                            <strong>Paperless Billing</strong> to view this bill
                            electronically.
                          </p>
                          <a class='display-block text-center' href='/ebill'>Enroll Now</a>
                        </div>"
                        >
                          <svg
                            aria-hidden="true"
                            class="icon color-blue icon-question"
                            role="img"
                          >
                            <use xlinkHref="#icon-question"></use>
                          </svg>
                          <span class="tooltip tooltip__trigger">
                            <span class="a11y-hide">
                              Click to view paperless tooltip
                            </span>
                          </span>
                        </span>
                      </div>
                    </div>
                  );
                }
              } else if (row.Type === "Payment" && row.CanBeCancelled) {
                return (
                  <div class="table-cell-wrapper">
                    <div class="table-cell-label">Cancel Payment</div>
                    <div class="table-cell-content">
                      <a href="/payment/paynow">Cancel Payment</a>
                    </div>
                  </div>
                );
              }
              return null;
            },
          },
        },
      };
    },
    methods: {
      setTooltip() {
        this.$nextTick(() => {
          const tooltipButtons = selectAll(".tooltip__container.paperless");
          if (tooltipButtons) {
            tippy(tooltipButtons, {
              arrow: true,
              flip: true,
              interactive: true,
              theme: "nisource",
              trigger: "mouseenter",
              zIndex: 90,
            });
          }
        });
      },
      togglePanel(event) {
        event.preventDefault();
        toggleExpandablePanel(event);
        // push GTM events to the data layer
        const element = event.srcElement;
        const buttonelement = element.closest(".expandable-panel-expand");
        if (buttonelement.getAttribute("aria-expanded") === "true") {
          dataLayerPush("DashboardRecentActivity");
        }
      },
    },
    created() {
      Event.$on('vue-tables.pagination', () => {
        this.setTooltip();
      });
    },
    mounted() {
      this.setTooltip();
      AdjustHistoryTableMargin();
      window.addEventListener('resize', AdjustHistoryTableMargin);
    },
  });
}



// WEBPACK FOOTER //
// ./src/assets/toolkit/scripts/portal/historyTable.js